/**
 * @generated SignedSource<<708a84d22562686aa3629d24de5dd45a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PlaceholderSidePanel_user$data = {
  readonly id: number;
  readonly " $fragmentSpreads": FragmentRefs<"PersonSidePanelNotes_user">;
  readonly " $fragmentType": "PlaceholderSidePanel_user";
};
export type PlaceholderSidePanel_user$key = {
  readonly " $data"?: PlaceholderSidePanel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PlaceholderSidePanel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PlaceholderSidePanel_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PersonSidePanelNotes_user"
    }
  ],
  "type": "users",
  "abstractKey": null
};

(node as any).hash = "49d103d01beda7cf6e890d1945c2a47c";

export default node;
